<!-- header -->
<header class="container-fluid  home-header nimate__animated animate__fadeIn wow">
  <div class="row main-nav-container">
    <div class="col d-flex">
      <a class="d-inline-block bg-white academy-header-logo">
        <img src="assets/img/logo.jpg" class="d-block" alt="أكاديمية الفنون">
      </a>
    </div>
    
    <div class="col-auto align-items-center d-flex">
     
      <!-- <a >
        سجل الان
       
      </a> -->
      <button [disabled]="!IS_REGISTRATION_OPEN" data-bs-toggle="modal"  data-bs-target="#conditionsModel"
      class="btn btn-primary fs-5 me-1 register d-flex align-items-center">سجل الان</button>
      <div data-bs-toggle="offcanvas" href="#offcanvasNav" role="button" aria-controls="offcanvasNav">
        <a class="btn nav-button bg-white text-black p-3 d-block">
          <i class="icon-nav lh-1 d-block fs-4"></i>
        </a>
      </div>

    </div>
  </div>
</header>

<!-- <div class="cover"></div> -->
<!-- <mat-spinner></mat-spinner> -->
<!-- END header -->
<main id="mainContent" tabindex="-1">
<!--about academy-->
<section class="academy-hero position-relative overflow-hidden">
  <div class="academy-hero-bg"></div>
  <div class="academy-hero-overlay"></div>
  <div class="container-fluid max-fluid position-relative academy-hero-inner py-5">
    <div class="row">
      <div class="col-xl-8 col-lg-10 mx-auto text-center text-white">
        <span class="academy-hero-eyebrow d-inline-block animate__animated animate__fadeInUp animate__faster wow">
          صرح الفنون في مصر والوطن العربي
        </span>
        <h1
          class="academy-hero-title heading-font fw-normal mb-4 animate__animated animate__fadeInUp animate__faster wow">
          أﻛﺎدﻳﻤﻴﺔ اﻟﻔﻨﻮن
        </h1>
        <p class="academy-hero-desc fs-5 fw-medium mb-5 mx-auto animate__animated animate__fadeInUp animate__fast wow">
          {{massege}}
        </p>
        <ul
          class="academy-hero-stats list-unstyled pe-0 d-flex text-center justify-content-center animate__animated animate__fadeInUp wow">
          <li class="academy-hero-stat px-3 flex-fill">
            <p class="heading-font fw-bold fs-1 lh-1 mb-0">1969</p>
            <label class="mb-0 fs-6 fw-medium">
              إﻓﺘﺘﺢ ﻓﻲ
            </label>
          </li>
          <li class="academy-hero-stat px-3 flex-fill">
            <p class="heading-font fw-bold fs-1 lh-1 mb-0">{{faculty_count}}</p>
            <label class="mb-0 fs-6 fw-medium">
              معاهد
            </label>
          </li>
        </ul>

      <!-- <div class="join-now mt-5 row align-items-center animate__animated animate__fadeInUp wow">
        <div class="col col-xl-6">
          <a class="btn btn-primary text-white d-flex align-items-center text-start py-3 px-4 fs-6">
            <div class="flex-fill pe-3">
              انضم إلى العام الدراسي الجديد في سبتمبر
              <span class="d-block fw-bold pt-1"> سجل الان </span>
            </div>
            <i class="icon-arrow-sm default d-block overflow-hidden"></i>
          </a>
        </div>
        <label class="text-gray fs-5 fw-medium ps-4 col-auto d-none d-md-block">
          متبقي 27 يوم فقط للتسجيل !
        </label>
      </div> -->

      </div>
    </div>
  </div>
</section>
<!--END about academy-->
<!-- Academy identity : Vision -> Mission -> Goals -->
<section class="container-fluid max-fluid identity-section py-5 mb-5">
  <div class="row">
    <div class="col-xl-9 col-lg-11 mx-auto">
      <ul class="identity-timeline list-unstyled pe-0 mb-0">

        <li class="identity-item animate__animated animate__fadeInUp animate__faster wow">
          <span class="identity-num heading-font">01</span>
          <div class="identity-body">
            <h3 class="heading-font identity-title">الرؤية</h3>
            <p class="fs-5 fw-medium mb-0">{{Vission}}</p>
          </div>
        </li>

        <li class="identity-item animate__animated animate__fadeInUp animate__fast wow">
          <span class="identity-num heading-font">02</span>
          <div class="identity-body">
            <h3 class="heading-font identity-title">الرسالة</h3>
            <p class="fs-5 fw-medium mb-0">{{misson}}</p>
          </div>
        </li>

        <li class="identity-item animate__animated animate__fadeInUp wow">
          <span class="identity-num heading-font">03</span>
          <div class="identity-body">
            <h3 class="heading-font identity-title">الأهداف والقيم</h3>
            <p class="fs-5 fw-medium mb-0">{{goals}}</p>
          </div>
        </li>

      </ul>
    </div>
  </div>
</section>
<!-- Institutes carousel -->
<section class="institutes-section">
  <div class="institutes-inner">
    <div class="institutes-head">
      <div class="institutes-head-title">
        <span class="institutes-head-accent"></span>
        <div>
          <h2 class="heading-font fw-bold mb-0">معاهد الأكاديمية</h2>
          <p class="institutes-head-sub mb-0">معاهد متخصصة في مختلف فنون الأداء والإبداع</p>
        </div>
      </div>
    </div>

    <swiper [config]="instituteCardsConfig" dir="rtl" class="institutesSwiper"
      (click)="onInstituteClick($event)">
      <div class="swiper-wrapper">
        <div class="swiper-slide institute-slide" *ngFor="let item of faucltyArr">
          <div class="institute-card" [attr.data-id]="item.ID" role="button" tabindex="0"
            (keydown.enter)="openInstitute(item)" (keydown.space)="openInstitute(item)">
            <div class="institute-card-media">
              <img [src]="item.SLIDER_IMAGE" [alt]="item.FACULTY_NAME" loading="lazy" />
              <span class="institute-card-year" *ngIf="item.DATE_ESTABLISH">تأسس {{item.DATE_ESTABLISH}}</span>
            </div>
            <div class="institute-card-body">
              <h3 class="institute-card-title heading-font">{{item.FACULTY_NAME}}</h3>
              <p class="institute-card-about" *ngIf="item.ABOUT_FACULTY">{{item.ABOUT_FACULTY}}</p>
              <span class="institute-card-more">تصفّح المعهد <i class="icon-arrow-sm"></i></span>
            </div>
          </div>
        </div>
      </div>
    </swiper>
    <div class="swiper-pagination institutes-pagination"></div>
  </div>
</section>

<section style="margin-top: 3%">
  <div class="container-fluid floated-contatiner-top position-relative">
    <div class="row">
      <div class="col-lg-11 offset-lg-1 bg-white">
        <!--Fuculty Managers-->

        <section class="col pt-4 mt-2 pb-5">
          <h3 class="heading-font heading-style mb-4 fw-normal animate__animated animate__fadeInUp animate__faster wow">
            {{ Academy_Vice_president_name ? 'رئيس الاكاديمية و نائب رئيس الاكاديمية' : 'رئيس الاكاديمية' }}
          </h3>
          <div class="manger-swiper-container">
            <div class="swiper managers-swiper" [class.single-manager]="!Academy_Vice_president_name">
              <swiper [config]="mangerConfig">
                <div class="swiper-wrapper">
                  <div class="swiper-slide">
                    <div class="overflow-hidden latest swiper-element manager-card">
                      <div class="manager-photo position-relative overflow-hidden">
                        <img class="hover-scale fit-img position-absolute"
                          [src]="Academy_president_img ? Academy_president_img : 'assets/img/instructor-default.png'" alt="">
                      </div>
                      <div class="manager-info bg-white text-black p-4">
                        <h4 class="fw-medium fs-4 mb-0 pb-2 lh-md">
                          أ.د.{{Academy_president_name}}
                        </h4>
                        <span class="d-inline-block pt-1 border-top border-primary text-primary fs-6 fw-medium">رئيس الاكاديمية</span>
                        <p class="pt-2 mb-0 opacity-75 fw-medium">
                          {{Academy_president_about}}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="swiper-slide" *ngIf="Academy_Vice_president_name">
                    <div class="overflow-hidden swiper-element manager-card">
                      <div class="manager-photo position-relative overflow-hidden">
                        <img class="hover-scale fit-img position-absolute"
                          [src]="Academy_Vice_president_img ? Academy_Vice_president_img : 'assets/img/instructor-default.png'" alt="">
                      </div>
                      <div class="manager-info bg-white text-black p-4">
                        <h4 class="fw-medium fs-4 mb-0 pb-2 lh-md">
                          أ.د.{{Academy_Vice_president_name}}
                        </h4>
                        <span class="d-inline-block pt-1 border-top border-primary text-primary fs-6 fw-medium"> نائب الرئيس </span>
                        <p class="pt-2 mb-0 opacity-75 fw-medium">
                          {{Academy_Vice_president_about}}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </swiper>
              <div class="swiper-pagination"></div>
            </div>
          </div>
        </section>


      </div>
    </div>
  </div>
</section>



<!--  -->

<!-- News grid -->
<section class="py-5 mb-5 news-container">
  <div class="container-fluid news-inner">
    <div class="news-head d-flex justify-content-between align-items-center flex-wrap">
      <div class="news-head-title d-flex align-items-center animate__animated animate__fadeInUp wow">
        <span class="news-head-accent"></span>
        <h2 class="heading-font fw-bold mb-0">آخر الأخبار</h2>
      </div>
      <a routerLink="/news_list" class="news-head-link fw-bold animate__animated animate__fadeInDown wow">
        كل الأخبار
        <i class="icon-arrow-sm"></i>
      </a>
    </div>

    <div class="news-grid">
      <a (click)="newsDetails(item.ID)" class="news-card animate__animated animate__fadeInUp wow" *ngFor="let item of newsArr2" role="button" tabindex="0" (keydown.enter)="newsDetails(item.ID)" (keydown.space)="newsDetails(item.ID)">
        <div class="news-card-media overflow-hidden">
          <img class="news-card-img" src="{{item.IMG_PATH}}" alt="">
          <span class="news-card-date">{{item.NEW_DATE | date : "yyyy/MM/dd"}}</span>
        </div>
        <div class="news-card-body">
          <h3 class="news-card-title heading-font">{{item.TITLE}}</h3>
          <span class="news-card-more">اقرأ المزيد <i class="icon-arrow-sm"></i></span>
        </div>
      </a>
      <a (click)="newsDetails(item.ID)" class="news-card animate__animated animate__fadeInUp wow" *ngFor="let item of newsArr" role="button" tabindex="0" (keydown.enter)="newsDetails(item.ID)" (keydown.space)="newsDetails(item.ID)">
        <div class="news-card-media overflow-hidden">
          <img class="news-card-img" src="{{item.IMG_PATH}}" alt="">
          <span class="news-card-date">{{item.NEW_DATE | date : "yyyy/MM/dd"}}</span>
        </div>
        <div class="news-card-body">
          <h3 class="news-card-title heading-font">{{item.TITLE}}</h3>
          <span class="news-card-more">اقرأ المزيد <i class="icon-arrow-sm"></i></span>
        </div>
      </a>
    </div>
  </div>
</section>
<!-- <section class="py-5 mb-5 news-container">
  <div class="container-fluid bg-secondary">
    <div class="row">
      <div class="col news-grid">
        <div class="swiper newsSwiper defult-pagination">
          <div class="swiper-wrapper">
            <div class="swiper-slide">
              <a
                class="position-relative main post overflow-hidden d-block text-white animate__animated animate__fadeInUp wow">
                <img class="hover-scale fit-img position-absolute" src="assets/img/news-1.jpg" alt="">
                <div class="position-absolute post-caption bottom-0 end-0">
                  <label class="px-3 pt-3 pb-2 mb-0">
                    06 ﻳﻮﻧﻴﻮ 2021
                  </label>
                  <p class="px-3 pt-8 overflow-hidden fs-4">
                    وزﻳﺮة اﻟﺜﻘﺎﻓﺔ ﺗﺘﻔﻘﺪ اﻟﺈﻧﺸﺎءات اﻟﺠﺪﻳﺪة ﺑﺄﻛﺎدﻳﻤﻴﺔ اﻟﻔﻨﻮن
                  </p>
                </div>
              </a>
            </div>
            <div class="swiper-slide">
              <div class="position-relative">
                <h3
                  class="heading-font heading-style fw-normal lh-base position-absolute text-white news-heading animate__fast animate__animated animate__fadeInUp wow">
                  <a>أخبار</a>
                </h3>
                <a
                  class="position-relative post overflow-hidden d-block text-white animate__animated animate__fadeInUp wow">
                  <img class="hover-scale fit-img position-absolute" src="assets/img/news2.jpg" alt="">
                  <div class="position-absolute post-caption top-0 start-0">
                    <label class="px-3 pt-3 pb-2 mb-0">
                      06 ﻳﻮﻧﻴﻮ 2021
                    </label>
                    <p class="px-3 pt-8 overflow-hidden fs-5">
                      اﻋﺮف ﺷﺮوط اﻟﺘﻘﺪم ﻟﺒﺮﻧﺎﻣﺞ اﻟﺒﻌﺜﺎت اﻟﺘﺪرﻳﺒﻴﺔ ﻟﺄﻋﻀﺎء ﻫﻴﺌﺔ اﻟﺘﺪرﻳﺲ
                    </p>
                  </div>
                </a>
              </div>
            </div>
            <div class="swiper-slide">
              <a
                class="position-relative post overflow-hidden d-block text-white animate__animated animate__fadeInUp wow">
                <img class="hover-scale fit-img position-absolute" src="assets/img/news3.jpg" alt="">
                <div class="position-absolute post-caption bottom-0 end-0">
                  <label class="px-3 pt-3 pb-2 mb-0">
                    06 ﻳﻮﻧﻴﻮ 2021
                  </label>
                  <p class="px-3 pt-8 overflow-hidden fs-5">
                    ﺗﻮﻗﻴﻊ ﺑﺮوﺗﻮﻛﻮل ﺗﻌﺎون ﺑﻴﻦ أﻛﺎدﻳﻤﻴﺔ اﻟﻔﻨﻮن واﻟﻤﺮﻛﺰ اﻟﻘﻮﻣﻲ ﻟﻠﺘﻌﻠﻴﻢ اﻟﺎﻟﻜﺘﺮوﻧﻲ
                  </p>
                </div>
              </a>
            </div>
            <div class="swiper-slide">
              <a
                class="position-relative post overflow-hidden d-block text-white animate__animated animate__fadeInUp wow">
                <img class="hover-scale fit-img position-absolute" src="assets/img/research3.jpg" alt="">
                <div class="position-absolute post-caption top-0 start-0">
                  <label class="px-3 pt-3 pb-2 mb-0">
                    06 ﻳﻮﻧﻴﻮ 2021
                  </label>
                  <p class="px-3 pt-8 overflow-hidden fs-5">
                    اﻋﺮف ﺷﺮوط اﻟﺘﻘﺪم ﻟﺒﺮﻧﺎﻣﺞ اﻟﺒﻌﺜﺎت اﻟﺘﺪرﻳﺒﻴﺔ ﻟﺄﻋﻀﺎءﻫﻴﺌﺔ اﻟﺘﺪرﻳﺲ
                  </p>
                </div>
              </a>
            </div>
            <div class="swiper-slide">
              <a
                class="position-relative post overflow-hidden d-block text-white animate__animated animate__fadeInUp wow">
                <img class="hover-scale fit-img position-absolute" src="assets/img/research2.jpg" alt="">
                <div class="position-absolute post-caption bottom-0 end-0">
                  <label class="px-3 pt-3 pb-2 mb-0">
                    06 ﻳﻮﻧﻴﻮ 2021
                  </label>
                  <p class="px-3 pt-8 overflow-hidden fs-5">
                    ﺗﻮﻗﻴﻊ ﺑﺮوﺗﻮﻛﻮل ﺗﻌﺎون ﺑﻴﻦ أﻛﺎدﻳﻤﻴﺔ اﻟﻔﻨﻮن واﻟﻤﺮﻛﺰ اﻟﻘﻮﻣﻲ ﻟﻠﺘﻌﻠﻴﻢ اﻟﺎﻟﻜﺘﺮوﻧﻲ
                  </p>
                </div>
              </a>
            </div>

          </div>
          
          <div class="swiper-pagination"></div>

        </div>
        <div class="swiper-more-link text-end">
          <a
            class="text-primary d-inline-block fw-bold position-relative mb-1 animate__animated animate__fadeInDown wow">
            كل الأخبار
            <i class="icon-arrow-sm position-relative"></i>
          </a>
        </div>
      </div>
    </div>
  </div>
</section> -->
<!--End News slider -->

<!-- academy programs -->
<!-- <section class="container-fluid py-5 ">
  <h2 class="heading-font heading-style mb-5 fw-normal animate__faster animate__animated animate__fadeInUp wow">
    اﻟﺪراﺳﺔ ﻓﻲ أﻛﺎدﻳﻤﻴﺔ اﻟﻔﻨﻮن</h2>
  <div class="row">
    <div class="col-md-6 col-lg mb-5 animate__animated animate__fadeInUp animate__faster  wow">
      <a class="position-relative hover-img overflow-hidden programs-link d-block">
        <img class="w-100" src="assets/img/ba.jpg" alt="">
        <div class="position-absolute bottom-0 end-0 p-4 bg-white fs-4 text-black fw-medium d-flex align-items-center">
          دراﺳﺎت اﻟﺒﻜﺎﻟﻮرﻳﻮس
          <i class="icon-arrow-sm text-primary ms-1"></i>
        </div>
      </a>
    </div>
    <div class="col-md-6 col-lg mb-5 animate__animated animate__fadeInUp animate__fast wow">
      <a class="position-relative hover-img overflow-hidden programs-link d-block">
        <img src="assets/img/master.jpg" alt="">
        <div class="position-absolute top-0 start-0 p-4 bg-white fs-4 text-black fw-medium d-flex align-items-center">
          اﻟﺪراﺳﺎت اﻟﻌﻠﻴﺎ
          <i class="icon-arrow-sm text-primary ms-1"></i>
        </div>
      </a>
    </div>
    <div class="col-md-6 col-lg mb-5 animate__animated animate__fadeInUp wow">
      <a class="position-relative hover-img overflow-hidden programs-link d-block">
        <img src="assets/img/freelance.jpg" alt="">
        <div class="position-absolute bottom-0 end-0 p-4 bg-white fs-4 text-black fw-medium d-flex align-items-center">
          اﻟﺪراﺳﺎت اﻟﺤﺮة
          <i class="icon-arrow-sm text-primary ms-1"></i>
        </div>
      </a>
    </div>
  </div>
</section> -->
<!--END academy programs -->



<!-- applay -->
<!-- <section class="pb-5 mb-5">
  <div class="position-relative overflow-hidden container-fluid">
    <div class="bg-gray-absolute position-absolute top-0 h-100 d-none d-lg-block"></div>
    <div class="row position-relative">
      <div class="col-lg-7 pb-lg-5 pb-4 mt-lg-5 pt-lg-5  animate__animated animate__fadeInDown wow">
        <h2 class="heading-font heading-style mb-1 fw-normal pt-lg-4">اﺟﻌﻞ ﺷﻐﻔﻚ ﻋﻤﻠﻚ </h2>
        <p class="fs-5 fw-medium mb-0">ﺳﻮف ﻳﺘﻢ ﻓﺘﺢ ﺑﺎب اﻟﻘﺒﻮل ﻓﻲ اﻟﻨﻈﺎم اﻟﻤﻮازي و دﺑﻠﻮم اﻟﺪراﺳﺎت اﻟﺤﺮة آﺧﺮ ﺷﻬﺮ ﻳﻨﺎﻳﺮ
        </p>
      </div>
      <div class="col-lg-4 position-relative nimate__faster animate__animated animate__fadeInLeft wow">
        <img class="position-absolute top-0 start-0 apply-img-bg" src="assets/img/search-form.jpg" alt="">
      </div>
    </div>
    <div class="row">
      <div
        class="col-lg-11 find-program-form position-relative apply-search-main py-lg-5 py-4 animate__animated animate__fadeInUp wow">
        <div class="bg-mode-darken top-0 start-0 w-100 h-100 position-absolute"></div>
        <h5 class="text-white position-relative fs-4 mb-md-5 mb-4 lh-md">
          اﺑﺤﺚ ﻋﻦ اﻟﺒﺮﻧﺎﻣﺞ و اﻟﻤﻌﻬﺪ اﻟﻤﻨﺎﺳﺐ ﻟﻚ ﺗﻌﺮف ﻋﻠﻰ ﺷﺮوط اﻟﻘﺒﻮل و اﻟﻤﻮاد و اﻟﺸﻬﺎده اﻟﺘﻲ ﻳﺘﻢ اﻟﺤﺼﻮل ﻋﻠﻴﻬﺎ و أﻗﺮب
          ﻣﻮﻋﺪ ﻟﻠﺘﺴﺠﻴﻞ
        </h5>
        <form class="row my-3 pe-lg-5">
          <div class="col-md pb-3 pb-md-0">
            <div class="floating-label-select position-relative">
              <select class="floating-select form-select border-0" onclick="this.setAttribute('value', this.value);"
                value="">
                <option value=""></option>
                <option value="1">ﺒﻜﺎﻟﻮرﻳﻮس</option>
                <option value="2">ثانويه عامه</option>
              </select>
              <label>اﻟﻤﺆﻫﻞ اﻟﺪراﺳﻲ</label>
            </div>
          </div>
          <div class="col-md pe-md-0 pb-3 pb-md-0">
            <div class="floating-label-select position-relative">
              <select class="floating-select form-select border-0" onclick="this.setAttribute('value', this.value);"
                value="">
                <option value=""></option>
                <option value="1">اﻟﻔﻨﻮن اﻟﻤﺴﺮﺣﻴﺔ</option>
                <option value="2">اﻟﻜﻮﻧﺴﺮﻓﺘﻮار</option>
                <option value="3">اﻟﺒﺎﻟﻴﻪ</option>
              </select>
              <label> إﺧﺘﺮ اﻟﻤﻌﻬﺪ</label>
            </div>
          </div>
          <div class="col-md pe-md-0 pb-3 pb-md-0">
            <div class="floating-label-select position-relative">
              <select class="floating-select form-select border-0 fw-medium"
                onclick="this.setAttribute('value', this.value);" value="">
                <option value=""></option>
                <option value="1">ﺒﻜﺎﻟﻮرﻳﻮس</option>
                <option value="2">دراﺳﺎت حرة</option>
              </select>
              <label>البرنامج</label>
            </div>
          </div>

          <div class="col-md-auto pe-md-0">
            <button
              class="btn bg-white search-btn position-relative h-100 d-flex align-items-center justify-content-center">
              <i class="icon-search"></i>
              <span class="d-inline-block d-md-none fs-4 fw-medium py-2 pe-2">
                بحث
              </span>
            </button>
          </div>

        </form>
      </div>
    </div>
  </div>


</section> -->
<!-- END applay -->

<!-- events -->
<section class="py-5 mb-5 events-container" *ngIf="events?.length">
  <div class="container-fluid events-inner">
    <div class="events-head d-flex justify-content-between align-items-center flex-wrap">
      <div class="events-head-title d-flex align-items-center animate__animated animate__fadeInUp wow">
        <span class="events-head-accent"></span>
        <h2 class="heading-font fw-bold mb-0">الفعاليات القادمة</h2>
      </div>
      <a routerLink="/events" class="events-head-link fw-bold animate__animated animate__fadeInDown wow">
        كل الفعاليات
        <i class="icon-arrow-sm"></i>
      </a>
    </div>

    <swiper [config]="eventConfig" class="swiper eventSwiper">
      <div class="swiper-wrapper">
        <div class="swiper-slide event-slide" *ngFor="let item of events">
          <a (click)="eventDetails(item.ID)" class="event-card animate__animated animate__fadeInUp wow" role="button" tabindex="0" (keydown.enter)="eventDetails(item.ID)" (keydown.space)="eventDetails(item.ID)">
            <img class="event-card-img" src="{{item.IMG_PATH}}" alt="">
            <span class="event-card-badge">
              <span class="event-card-day">{{item.START_DATE | date:'dd'}}</span>
              <span class="event-card-month">{{item.START_DATE | date:'MM/yyyy'}}</span>
            </span>
            <div class="event-card-overlay">
              <span class="event-card-faculty" *ngIf="item.FACULTY_NAME">{{item.FACULTY_NAME}}</span>
              <h4 class="event-card-title heading-font">{{item.TITLE}}</h4>
              <span class="event-card-more">اعرف التفاصيل <i class="icon-arrow-sm"></i></span>
            </div>
          </a>
        </div>
      </div>
      <div class="swiper-pagination events-pagination"></div>
    </swiper>
  </div>
</section>
<!-- END events -->

<!--Graduated-->
<section class="py-5 mb-5 graduates-container" *ngIf="graduatesList?.length">
  <div class="container-fluid graduates-inner">
    <div class="graduates-head d-flex align-items-center animate__animated animate__fadeInUp wow">
      <span class="graduates-head-accent"></span>
      <h2 class="heading-font fw-bold mb-0">خريجو أكاديمية الفنون</h2>
    </div>

    <swiper *ngIf="graduatesList?.length" class="swiper graduatesSwiper" [config]="gradConfig">
      <div class="swiper-wrapper">
        <div class="swiper-slide graduate-slide" *ngFor="let grad of graduatesList">
          <div class="graduate-card">
            <div class="graduate-card-media">
              <img class="graduate-card-img" [src]="grad.image" alt="">
            </div>
            <div class="graduate-card-body">
              <h3 class="graduate-card-name heading-font">{{grad.name}}</h3>
              <span class="graduate-card-faculty">{{grad.faculty_name}}</span>
            </div>
          </div>
        </div>
        <!-- <div class="swiper-slide">
            <div class="graduated-year-list border-start position-relative px-3 pt-5">
              <label class="position-absolute top-0 start-0 heading-font text-primary fw-bold fs-1 lh-1 mt-3 ps-4">
                1976
              </label>
              <ul class="row list-unstyled px-3 pt-5 graduated-list">
                <li class="col position-relative">
                  <div class="student-img position-relative overflow-hidden">
                    <img class="position-absolute fit-img" src="assets/img/graduate4.jpg" alt="">
                  </div>
                  <div class="position-absolute student-info bg-white p-3">
                    <p class="fs-4 fw-medium mb-2">رشوان توفيق</p>
                    <label class="text-black-50 mb-0">فنون المسرحية</label>
                  </div>
                </li>
                <li class="col position-relative">
                  <div class="student-img position-relative overflow-hidden">
                    <img class="position-absolute fit-img" src="assets/img/graduate3.jpg" alt="">
                  </div>
                  <div class="position-absolute student-info bg-white p-3">
                    <p class="fs-4 fw-medium mb-2">برلنتي عبد الحميد</p>
                    <label class="text-black-50 mb-0">فنون المسرحية</label>
                  </div>
                </li>
                <li class="col position-relative">
                  <div class="student-img position-relative overflow-hidden">
                    <img class="position-absolute fit-img" src="assets/img/graduate2.jpg" alt="">
                  </div>
                  <div class="position-absolute student-info bg-white p-3">
                    <p class="fs-4 fw-medium mb-2">نور الشريف</p>
                    <label class="text-black-50 mb-0">فنون المسرحية</label>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="swiper-slide">
            <div class="graduated-year-list border-start position-relative px-3 pt-5">
              <label class="position-absolute top-0 end-0 heading-font text-primary fw-bold fs-1 lh-1 mt-3 pe-4">
                1976
              </label>
              <ul class="row list-unstyled px-3 pt-5 graduated-list">
                <li class="col position-relative">
                  <div class="student-img position-relative overflow-hidden">
                    <img class="position-absolute fit-img" src="assets/img/graduate1.jpg" alt="">
                  </div>
                  <div class="position-absolute student-info bg-white p-3">
                    <p class="fs-4 fw-medium mb-2">رشوان توفيق</p>
                    <label class="text-black-50 mb-0">فنون المسرحية</label>
                  </div>
                </li>

              </ul>
            </div>
          </div> -->
      </div>
      <div class="swiper-pagination graduates-pagination"></div>
    </swiper>

    <!-- <div thumbsSlider="" class="swiper timelineYear">
      <div class="swiper-wrapper">
        <div class="swiper-slide">
          <span class="d-block fs-4 fw-medium heading-font lh-1 py-3 ps-2">
            1976
          </span>
        </div>
        <div class="swiper-slide">
          <span class="d-block fs-4 fw-medium heading-font lh-1 py-3 ps-2">
            1973
          </span>
        </div>
        <div class="swiper-slide">
          <span class="d-block fs-4 fw-medium heading-font lh-1 py-3 ps-2">
            1994
          </span>
        </div>
      </div>
    </div> -->
  </div>

</section>
<!--END Graduated-->

<!-- gallrey -->
<section class="py-5 mb-5 gallery-container" *ngIf="gallery?.length">
  <div class="container-fluid gallery-inner">
    <div class="gallery-head d-flex justify-content-between align-items-center flex-wrap">
      <div class="gallery-head-title d-flex align-items-center animate__animated animate__fadeInUp wow">
        <span class="gallery-head-accent"></span>
        <h2 class="heading-font fw-bold mb-0">معرض الصور</h2>
      </div>
      <a class="gallery-head-link fw-bold animate__animated animate__fadeInDown wow">
        كل الصور
        <i class="icon-arrow-sm"></i>
      </a>
    </div>

    <swiper *ngIf="gallery?.length" [config]="galleryConfig" (click)="onGalleryClick($event)"
      class="swiper gallerySwiper">
      <div class="swiper-wrapper">
        <div class="swiper-slide gallery-slide" *ngFor="let item of gallery">
          <div class="gallery-card animate__animated animate__fadeInUp wow"
               data-bs-toggle="modal" data-bs-target="#imagePoup">
            <img class="gallery-card-img" [src]="item.image_path" alt="">
            <span class="gallery-card-overlay">
              <span class="gallery-card-icon"><i class="icon-search"></i></span>
            </span>
          </div>
        </div>
      </div>
      <div class="swiper-pagination gallery-pagination"></div>
    </swiper>
  </div>
</section>



<div class="modal fade gallery-image-modal" id="imagePoup" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-centered">
        <div class="modal-content">
            <button type="button" class="gallery-image-close" data-bs-dismiss="modal" aria-label="إغلاق">
                <span aria-hidden="true">&times;</span>
            </button>
            <div class="modal-body p-0">
                <img class="w-100" [src]="src_image" alt="صورة">
            </div>
        </div>
    </div>
</div>
<!-- END gallrey -->
</main>

<!-- footer -->
<!-- <app-footer></app-footer> -->
<!-- end footer -->

<!-- <div class="offcanvas offcanvas-end main-nav" tabindex="-1" id="offcanvasNav" aria-labelledby="offcanvasNavLabel">
    <div class="offcanvas-header align-items-end">
      <h5 class="offcanvas-title mx-auto" id="offcanvasNavLabel">
        <a class="d-block p-3">
          <img class="logo" src="assets/img/logo.jpg" alt="أكاديمية الفنون">
        </a>
      </h5>
      <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
    </div>
    <div class="offcanvas-body px-0">
      <a class="nav-search d-flex bg-light px-3 py-3 text-black">
        <label class="mb-0 col">
          بحث
        </label>
        <div class="col-auto">
          <i class="icon-search"></i>
        </div>
      </a>
      <div class="academy-nav mt-3">
        <div class="accordion" id="accordionNav">
          <div class="accordion-item border-0">
            <h2 class="accordion-header" id="headingInstitutes">
              <button class="accordion-button bg-transparent fw-medium fs-7 text-black border-bottom" type="button" data-bs-toggle="collapse" data-bs-target="#collapseInstitutes" aria-expanded="true" aria-controls="collapseInstitutes">
                المعاهد
              </button>
            </h2>
            <div id="collapseInstitutes" class="accordion-collapse collapse show" aria-labelledby="headingInstitutes" data-bs-parent="#accordionNav">
              <div class="accordion-body px-0 border-bottom pb-0">
                <ul class="list-unstyled pe-0">
                  <li class="px-3"> 
                    <a>
                      اﻟﻔﻨﻮن اﻟﻤﺴﺮﺣﻴﺔ
                    </a>
                  </li>
                  <li  class="px-3">
                    <a>
                      اﻟﻜﻮﻧﺴﺮﻓﺘﻮار
                    </a>
                  </li>
                  <li class="px-3">
                    <a>
                      اﻟﺒﺎﻟﻴﻪ
                    </a>
                  </li>
                  <li class="px-3">
                    <a>
                      اﻟﺴﻴﻨﻤﺎ
                    </a>
                  </li>
                  <li class="px-3">
                    <a>
                      اﻟﻤﻮﺳﻴﻘﻰ اﻟﻌﺮﺑﻴﺔ
                    </a>
                  </li>
                  <li class="px-3">
                    <a>
                      اﻟﻨﻘﺪ اﻟﻔﻨﻲ

                    </a>
                  </li>
                  <li class="px-3">
                    <a>
                      اﻟﻔﻨﻮن اﻟﺸﻌﺒﻴﺔ
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="accordion-item border-0">
            <h2 class="accordion-header" id="headingAbout">
              <button class="accordion-button bg-transparent fw-medium fs-7 text-black border-bottom collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapsePrograms" aria-expanded="false" aria-controls="collapsePrograms">
                البرامج اﻟﺄﻛﺎدﻳﻤﻴﺔ 
              </button>
            </h2>
            <div id="collapsePrograms" class="accordion-collapse collapse" aria-labelledby="headingAbout" data-bs-parent="#accordionNav">
              <div class="accordion-body px-0 border-bottom pb-0">
                <ul class="list-unstyled pe-0">
                  <li class="px-3">
                    <a>
                      دراﺳﺎت اﻟﺒﻜﺎﻟﻮرﻳﻮس
                    </a>
                  </li>
                  <li class="px-3">
                    <a>
                      اﻟﺪراﺳﺎت اﻟﻌﻠﻴﺎ
                    </a>
                  </li>
                  <li class="px-3">
                    <a>
                      اﻟﺪراﺳﺎت اﻟﺤﺮة
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="accordion-item border-0">
            <h2 class="accordion-header" >
              <button class="accordion-button bg-transparent fw-medium fs-7 text-black border-bottom no-body collapsed" type="button">
                اﻟﺘﻘﺪﻳﻢ واﻟﻘﺒﻮل
              </button>
            </h2>
          </div>
          <div class="accordion-item border-0">
            <h2 class="accordion-header">
              <button class="accordion-button bg-transparent fw-medium fs-7 text-black border-bottom no-body collapsed" type="button">
                دراﺳﺎت و ﺑﺤﻮث
              </button>
            </h2>
          </div>
          <div class="accordion-item border-0">
            <h2 class="accordion-header">
              <button class="accordion-button bg-transparent fw-medium fs-7 text-black border-bottom no-body collapsed" type="button">
                الأخبار
              </button>
            </h2>
          </div>
          <div class="accordion-item border-0">
            <h2 class="accordion-header">
              <button class="accordion-button bg-transparent fw-medium fs-7 text-black border-bottom no-body collapsed" type="button">
                الفعاليات
              </button>
            </h2>
          </div>
          <div class="accordion-item border-0">
            <h2 class="accordion-header" id="headingPrograms">
              <button class="accordion-button bg-transparent fw-medium fs-7 text-black border-bottom collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseAbout" aria-expanded="false" aria-controls="collapseAbout">
                ﻋﻦ اﻟﺄﻛﺎدﻳﻤﻴﺔ 
              </button>
            </h2>
            <div id="collapseAbout" class="accordion-collapse collapse" aria-labelledby="headingPrograms" data-bs-parent="#accordionNav">
              <div class="accordion-body px-0 border-bottom pb-0">
                <ul class="list-unstyled pe-0">
                  <li class="px-3">
                    <a>
                      نبذة عن اﻟﺄﻛﺎدﻳﻤﻴﺔ
                    </a>
                  </li>
                  <li class="px-3">
                    <a>
                      الهيكل التنظيمي 
                    </a>
                  </li>
                  <li class="px-3">
                    <a>
                      مقرات اﻟﺄﻛﺎدﻳﻤﻴﺔ
                    </a>
                  </li>
                  <li class="px-3">
                    <a>
                      اتصل بنا
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="accordion-item border-0">
            <h2 class="accordion-header" id="headingStudent">
              <button class="accordion-button bg-transparent fw-medium fs-7 text-black border-bottom collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseStudent" aria-expanded="true" aria-controls="collapseStudent">
                الطلبة
              </button>
            </h2>
            <div id="collapseStudent" class="accordion-collapse collapse" aria-labelledby="headingStudent" data-bs-parent="#accordionExample">
              <div class="accordion-body px-0 border-bottom pb-0">
              </div>
            </div>
          </div>
          <div class="accordion-item border-0">
            <h2 class="accordion-header">
              <button class="accordion-button bg-transparent fw-medium fs-7 text-black border-bottom no-body collapsed" type="button">
                ﻫﻴﺌﺔ اﻟﺘﺪرﻳﺲ واﻟﻤﻮﻇﻔﻴﻦ
              </button>
            </h2>
          </div>
          <div class="accordion-item border-0">
            <h2 class="accordion-header" id="headingGraduated">
              <button class="accordion-button bg-transparent fw-medium fs-7 text-black border-bottom collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseGraduated" aria-expanded="false" aria-controls="collapseGraduated">
                الخريجون
              </button>
            </h2>
            <div id="collapseGraduated" class="accordion-collapse collapse" aria-labelledby="headingGraduated" data-bs-parent="#accordionExample">
              <div class="accordion-body px-0 border-bottom pb-0">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div> -->